// (int) The current year
export const THIS_YEAR = +new Date().getFullYear();

// (int) The current month starting from 1 - 12
// 1 => January, 12 => December
export const THIS_MONTH = +new Date().getMonth() + 1;

export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const MONTH_NAMES_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Weeks displayed on calendar
export const CALENDAR_WEEKS = 6;

// Pads a string value with leading zeroes(0) until length is reached
// For example: zeroPad(5, 2) => "05"
export const zeroPad = (value, length) => {
  return `${value}`.padStart(length, '0');
};

// (int) Number days in a month for a given year from 28 - 31
export const getMonthDays = (month = THIS_MONTH, year = THIS_YEAR) => {
  const months30 = [4, 6, 9, 11];
  const leapYear = year % 4 === 0;

  return month === 2 ? (leapYear ? 29 : 28) : months30.includes(month) ? 30 : 31;
};

// (int) First day of the month for a given year from 1 - 7
// 1 => Sunday, 7 => Saturday
export const getMonthFirstDay = (month = THIS_MONTH, year = THIS_YEAR) => {
  return +new Date(`${year}-${zeroPad(month, 2)}-01`).getDay() + 1;
};

// (bool) Checks if a value is a date - this is just a simple check
export const isDate = (date) => {
  const isThisADate = Object.prototype.toString.call(date) === '[object Date]';
  const isValidDate = date && !Number.isNaN(date.valueOf());

  return isThisADate && isValidDate;
};

// (bool) Checks if two date values are of the same month and year
export const isSameYear = (date, basedate) => {
  if (!(isDate(new Date(date)) && isDate(new Date(basedate)))) return false;

  const basedateYear = new Date(basedate).getFullYear();

  const dateYear = new Date(date).getFullYear();
  return basedateYear === dateYear;
};

// (bool) Checks if two date values are the same day
export const isSameDay = (date, basedate = new Date()) => {
  const date1 = new Date(date);
  const basedate1 = new Date(basedate);

  if (!(isDate(date) && isDate(basedate))) return false;

  const basedateDate = basedate1.getDate();
  const basedateMonth = +basedate1.getMonth() + 1;
  const basedateYear = basedate1.getFullYear();

  const dateDate = date1.getDate();
  const dateMonth = +date1.getMonth() + 1;
  const dateYear = date1.getFullYear();

  return +basedateDate === +dateDate && +basedateMonth === +dateMonth && +basedateYear === +dateYear;
};
